import { TableSplit } from '@carbon/icons-react';
import * as React from 'react';

import { DataSourcePlatform } from 'bones/constants/catalog';
import athena from 'bones/design-system/assets/dataSources/athena.svg';
import bigquery from 'bones/design-system/assets/dataSources/bigquery.svg';
import db2 from 'bones/design-system/assets/dataSources/db2.svg';
import derby from 'bones/design-system/assets/dataSources/derby.svg';
import exasol from 'bones/design-system/assets/dataSources/exasol.svg';
import h2 from 'bones/design-system/assets/dataSources/h2.svg';
import hive from 'bones/design-system/assets/dataSources/hive.svg';
import impala from 'bones/design-system/assets/dataSources/impala.svg';
import jira from 'bones/design-system/assets/dataSources/jira.svg';
import mssql from 'bones/design-system/assets/dataSources/mssql.svg';
import mysql from 'bones/design-system/assets/dataSources/mysql.svg';
import oracle from 'bones/design-system/assets/dataSources/oracle.svg';
import postgresql from 'bones/design-system/assets/dataSources/postgresql.svg';
import redshift from 'bones/design-system/assets/dataSources/redshift.svg';
import rest from 'bones/design-system/assets/dataSources/rest.svg';
import salesforce from 'bones/design-system/assets/dataSources/salesforce.svg';
import snowflake from 'bones/design-system/assets/dataSources/snowflake.svg';
import sparksqlDatabricks from 'bones/design-system/assets/dataSources/sparksql_databricks.svg';
import sparksql from 'bones/design-system/assets/dataSources/sparksql.svg';
import splunk from 'bones/design-system/assets/dataSources/splunk.svg';
import sybase from 'bones/design-system/assets/dataSources/sybase.svg';
import teradata from 'bones/design-system/assets/dataSources/teradata.svg';
import { Icon } from 'bones/design-system/components/icons/Icon';
import { getLocalName } from 'bones/utils/getLocalName';

export type DataSourceLogoProps = {
  iri: string;
};

export const getDataSourceLogo = (iri: string) => {
  switch (getLocalName(iri)) {
    case DataSourcePlatform.ATHENA:
      return athena;
    case DataSourcePlatform.BIGQUERY:
      return bigquery;
    case DataSourcePlatform.DB2:
      return db2;
    case DataSourcePlatform.DERBY:
      return derby;
    case DataSourcePlatform.EXASOL:
      return exasol;
    case DataSourcePlatform.H2:
      return h2;
    case DataSourcePlatform.HIVE:
      return hive;
    case DataSourcePlatform.IMPALA:
      return impala;
    case DataSourcePlatform.JIRA:
      return jira;
    case DataSourcePlatform.MSSQL:
      return mssql;
    case DataSourcePlatform.MYSQL:
      return mysql;
    case DataSourcePlatform.ORACLE:
      return oracle;
    case DataSourcePlatform.POSTGRESQL:
      return postgresql;
    case DataSourcePlatform.REDSHIFT:
      return redshift;
    case DataSourcePlatform.REST:
      return rest;
    case DataSourcePlatform.SALESFORCE:
      return salesforce;
    case DataSourcePlatform.SNOWFLAKE:
      return snowflake;
    case DataSourcePlatform.SPARKSQL_DATABRICKS:
      return sparksqlDatabricks;
    case DataSourcePlatform.SPARKSQL:
      return sparksql;
    case DataSourcePlatform.SPLUNK:
      return splunk;
    case DataSourcePlatform.SYBASE:
      return sybase;
    case DataSourcePlatform.TERADATA:
      return teradata;
    default:
      return null;
  }
};

export const DataSourceLogo: React.VFC<DataSourceLogoProps> = ({ iri }) => {
  const image = getDataSourceLogo(iri);
  return image ? (
    <img alt={iri} src={image} />
  ) : (
    <Icon IconComponent={TableSplit} size="xl" />
  );
};
